import {
  createFixedWidthView,
  useFixedRange
} from '~/modules/common/charts/timeline/calculations';
import { getSessionStorage } from '~/modules/common/hooks';

export const useGetChartDates = ({
  scale,
  width,
  anchorDate,
  sessionStorageKey,
  anchor = 0.2,
  isRmp2025Q3Enhancements = false
}) => {
  const { getPeriodCount } = createFixedWidthView(width, 456, 172);

  const hasStoredDate =
    sessionStorageKey && getSessionStorage(sessionStorageKey);

  let adjustedAnchorDate = anchorDate;

  /* ff ON - useFixedRange.anchor arg is not used, anchor is used for initial anchorDate calculcation only
     ff off - no change */
  if (isRmp2025Q3Enhancements && !hasStoredDate && anchor && width) {
    const periodCount = getPeriodCount(null, scale);
    const offsetPeriods = Math.floor((periodCount - 1) * anchor);

    adjustedAnchorDate = anchorDate.minus({ [scale]: offsetPeriods });
  }

  const {
    chartDates,
    onPrevious,
    onNext,
    dateRange,
    setScale: setFixedRangeScale,
    setDate
  } = useFixedRange({
    getPeriodCount,
    anchor: isRmp2025Q3Enhancements ? 0 : anchor,
    date: adjustedAnchorDate,
    scale,
    sessionStorageKey
  });

  return {
    chartDates,
    onPrevious,
    onNext,
    dateRange,
    setFixedRangeScale,
    setDate
  };
};
